// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vault_permission_level.proto (package domain, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file vault_permission_level.proto.
 */
export const file_vault_permission_level: GenFile = /*@__PURE__*/
  fileDesc("Chx2YXVsdF9wZXJtaXNzaW9uX2xldmVsLnByb3RvEgZkb21haW4qqQEKFFZhdWx0UGVybWlzc2lvbkxldmVsEiIKHlZBVUxUX1BFUk1JU1NJT05fTEVWRUxfVU5LTk9XThAAEiQKIFZBVUxUX1BFUk1JU1NJT05fTEVWRUxfUkVBRF9PTkxZEAESJQohVkFVTFRfUEVSTUlTU0lPTl9MRVZFTF9SRUFEX1dSSVRFEAISIAocVkFVTFRfUEVSTUlTU0lPTl9MRVZFTF9BRE1JThADQjBaLmdpdGxhYi5jb20vY290ZWNoZGUvbW9ub3JlcG8vYmFja2VuZC9kb21haW4vcGJiBnByb3RvMw");

/**
 * @generated from enum domain.VaultPermissionLevel
 */
export enum VaultPermissionLevel {
  /**
   * used as default value, see https://developers.google.com/protocol-buffers/docs/proto3#enum
   *
   * @generated from enum value: VAULT_PERMISSION_LEVEL_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: VAULT_PERMISSION_LEVEL_READ_ONLY = 1;
   */
  READ_ONLY = 1,

  /**
   * @generated from enum value: VAULT_PERMISSION_LEVEL_READ_WRITE = 2;
   */
  READ_WRITE = 2,

  /**
   * @generated from enum value: VAULT_PERMISSION_LEVEL_ADMIN = 3;
   */
  ADMIN = 3,
}

/**
 * Describes the enum domain.VaultPermissionLevel.
 */
export const VaultPermissionLevelSchema: GenEnum<VaultPermissionLevel> = /*@__PURE__*/
  enumDesc(file_vault_permission_level, 0);

